<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div id="map" class="map"></div>
    <c-detail
      v-if="showDt && JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
      ref="detailTask"
    ></c-detail>
    <f-detail
      v-if="showFpxmDt && JSON.stringify(fPoisiton) !== '{}'"
      :form="fPoisiton"
      class="detail"
      ref="fpDetailTask"
    ></f-detail>
  </div>
</template>

<script>
//种植业map
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import cDetail from "../util/fpxxkDetail";
import fDetail from "../util/fpxmDetail";
// import { findIndexByName } from "@/util/index";
import { mapGetters } from "vuex";
import {
  getFpxmData,
  getDemonstrationVillage,
  getInformationCard,
} from "@/api/map";
// import changeMap from "../util/changeMap";
export default {
  components: {
    cDetail,
    fDetail,
  },
  data() {
    return {
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      showDt: false,
      showFpxmDt: false,
      poisiton: {},
      fPoisiton: {},
      pointList: [],
      hoverArr: [],
      baseList: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [-10, 50],
      baseAnchor: [19, 48],
      mianArr: [],
      navIndex: 0,
      navName: "示范亮点行政村",
      sfc: [
        {
          name: "示范亮点行政村",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_lz_02/MapServer",
        },
        {
          name: "净化整治阶段自然村",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_ly_01/MapServer",
        },
        {
          name: "美化提升阶段自然村",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_xj_01/MapServer",
        },
        {
          name: "文明达标阶段自然村",
          url:
            window.__config.VUE_APP_MAP_URL +
            "/rest/services/440900/mm_xj_01/MapServer",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["granaryIndex"]),
  },
  mounted() {
    this.$bus.$on("ncchange", (val, index) => {
      //   let index = findIndexByName(val, this.sfc);
      console.log("navIndex", index);
      this.navIndex = index;
      this.navName = val;
      //   console.log(this.navName,'-----navName');
      if (this.navName !== "") {
        this.showDt = false;
      }
      //   if (this.navName !== "扶贫项目") {
      if (this.navIndex !== "1") {
        this.showFpxmDt = false;
      }
      //   if (index > -1) {
      //     // change map2
      //     this.changeMap(this.sfc[index]["url"]);
      //   } else {
      //     this.removemap2();
      //   }
      this.dataLoad();
    });
    this.initMap();
  },
  methods: {
    initMap() {
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrlColor;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl,
      });
      tileMapLayer.addTo(map);
      //   setTimeout(() => {
      // eslint-disable-next-line no-undef
      // $(".leaflet-control-attribution").empty();
      //   }, 300);
      this.map.setView(L.latLng(this.$config.sLat, this.$config.sLng), 0);

      this.dataLoad();
      //   this.nowZoom = this.map.getZoom();
      //   this.changeMap(this.sfc[0]["url"]);
      map.on("click", (e) => {
        console.log(e.latlng);
      });
      map.on("zoom", () => {
        this.showDt = false;
        this.showFpxmDt = false;
        this.poisiton = {};
        this.fPoisiton = {};
      });
      map.on("move", () => {
        this.showDt = false;
        this.showFpxmDt = false;
        this.poisiton = {};
        this.fPoisiton = {};
      });
    },
    //扶贫项目
    loadFpxmData(d) {
      console.log("d", d);
      getFpxmData(d).then((res) => {
        let data = res;
        data.data.map((ele) => {
          ele.img = "fpxm.png";
          ele.latitude = Number(ele.latitude);
          this.baseList.push(ele);
        });
        this.baseLoad();
      });
    },
    dataLoad() {
      this.baseList = [];
      //   if (this.navName === "扶贫项目") {
      //     this.loadFpxmData();
      //   }
      console.log(this.navIndex, "----navIndex");
      console.log(this.navName, "----this.navName");
      if (this.navIndex === 0) {
        this.getVillageData(this.navName); //示范村
      } else if (this.navIndex === 1) {
        //扶贫项目 类型
        this.loadFpxmData({ year: this.navName });
      } else if (this.navIndex === 2) {
        this.getInformationCardData();
      }
    },
    // 示范村
    getVillageData(type) {
      getDemonstrationVillage(type).then((res) => {
        let data = res;
        data.data.map((ele) => {
          ele.img = "fpxm.png";
          ele.latitude = Number(ele.latitude_);
          this.baseList.push(ele);
        });
        this.baseLoad();
      });
    },
    // f分镇情况
    getInformationCardData() {
      getInformationCard().then((res) => {
        let data = res;
        data.data.map((ele) => {
          ele.img = "fpxm.png";
          ele.latitude = Number(ele.latitude);
          this.baseList.push(ele);
        });
        this.baseLoad();
      });
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        let areaLayer = L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i],
        }).addTo(this.map);
        let lineUrl = require("images/index/map/line_map.png");
        let pointUrl = require("images/index/map/point.png");
        let myIcons = L.divIcon({
          html:
            "<div id='indicator-box'><div style='display:flex'><img src='" +
            pointUrl +
            "' /></div><div style='top:-20px;left:9px'><img src='" +
            lineUrl +
            "'/><span class='my-div-names'>" +
            this.areaList[i].name +
            "</span ></div></div>",
          className: "my-div-icon",
          iconAnchor: [-10, 0],
        });
        let areaPointLayer = L.marker([areaArr[i].lat, areaArr[i].lng], {
          icon: myIcons,
          attributes: this.areaList[i],
        }).addTo(this.map);
        this.mianArr.push(areaPointLayer);
        areaLayer.on("click", (e) => {
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
        areaLayer.on("mouseover", (it) => {
          this.ncCode = it.target.options.attributes.code;
        });
        areaLayer.on("mouseout", (it) => {
          this.ncCode = it.target.options.attributes.code;
          // this.deleHover(it);
        });
        areaPointLayer.on("click", (e) => {
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
        areaPointLayer.on("mouseover", (it) => {
          this.ncCode = it.target.options.attributes.code;
        });
      }
    },
    //科技中心数据加载
    pointLoad() {
      this.pointList.map((it) => {
        if (this.pointLayer) {
          this.map.removeLayer(this.pointLayer);
        }
        console.log("科技中心数据加载");
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          it.lat = it.latitude;
          it.lng = it.longitude;

          let pointUrl = require("images/map/" + it.img);
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><img style='width:35px' src='" +
              pointUrl +
              "' /></div>",
            className: "my-div-icon",
            iconAnchor: this.pointAnchor,
          });

          this.pointLayer = L.marker([it.lat, it.lng], {
            icon: pointIcon,
            attributes: it,
          }).addTo(this.map);
          this.pointLayer.on("click", (e) => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
          this.pointLayer.on("mouseover", (it) => {
            this.ncCode = it.target.options.attributes.code;
          });
        }
      });
    },
    //多基地数据加载
    baseLoad() {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.baseList.map((it) => {
        if (it.latitude) {
          //   let aPoint = new changeMap(it.latitude, it.longitude);
          //   it.lat = aPoint.lat;
          //   it.lng = aPoint.lng;
          it.lat = it.latitude;
          it.lng = it.longitude;
          let pointUrl = require("images/map/" + it.img);
          var myIcons;
          let html = "";
          let [...iconAnchor] = this.baseAnchor;
          if (this.navIndex === 0) {
            html =
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names'>" +
              it.name_ +
              "</span ></div>";
          } else if (this.navIndex === 2) {
            iconAnchor = [5, 10];
            html =
              "<div class='indicator-box point-box'><span class='point-s'></span></div>";
          } else {
            html =
              "<div class='indicator-box'><img src='" + pointUrl + "' /></div>";
          }
          myIcons = L.divIcon({
            html: html,
            className: "my-div-icon",
            iconAnchor: iconAnchor,
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it,
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          baseLayer.on("click", (e) => {
            if (!this.showDt && this.navName === "分镇情况") {
              this.showDt = true;
            }
            if (!this.showFpxmDt && this.navIndex === 1) {
              this.showFpxmDt = true;
            }
            this.poisiton.param = e.sourceTarget.options.attributes;
            if (this.navName === "分镇情况") {
              this.poisiton.x = e.containerPoint.x;
              this.poisiton.y = e.containerPoint.y;
              if (this.$refs.detailTask) {
                this.$nextTick(() => {
                  this.$refs.detailTask.getData(this.poisiton);
                });
              }
            }
            if (this.navIndex === 1) {
              this.fPoisiton.param = e.sourceTarget.options.attributes;
              this.fPoisiton.x = e.containerPoint.x;
              this.fPoisiton.y = e.containerPoint.y;
              if (this.$refs.fpDetailTask) {
                this.$nextTick(() => {
                  this.$refs.fpDetailTask.getData(this.fPoisiton);
                });
              }
            }
            if (this.navIndex === 0) {
              console.log(e.sourceTarget.options.attributes, "--------eee");
              let detailInfo = e.sourceTarget.options.attributes;
              detailInfo.desc = e.sourceTarget.options.attributes.info_;
              detailInfo.name = e.sourceTarget.options.attributes.name_;
              this.$store.dispatch("drawer/setGraphic", detailInfo);
              this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
            }
          });
          //   baseLayer.on("mouseover", it => {
          //     this.ncCode = it.target.options.attributes.code;
          //   });
        }
      });
      this.map.addLayer(this.basesGroup);
    },
  },
  destroyed() {
    this.$bus.$off("ncchange");
    this.showDt = false;
    this.showFpxmDt = false;
  },
};
</script>

<style lang="stylus" scoped>
.map
  background none !important
  width 100%
  height calc(100% + 105px)
  z-index 9

  // >>>.leaflet-tile-pane
  // display none
  >>>.leaflet-bar
    display none

  >>>.leaflet-bottom
    display none

  .ncDetail
    position absolute
>>>.my-div-names
    color #01a6b3
    background #001640
    border 1px solid #22b7c8
>>>.my-div-names
    &:before
        border-top: solid 10px #001640;
>>>.point-s
    width 100%
    height 100%
    display inline-block
    // position absolute
    // top -6px
    // left 50%
    // margin-left 10px
    border-radius 50%
    background-color #f3d013
>>>.point-box
  width 10px
  height 10px
>>>.town-name
    width 50px
    color #f3d013
</style>
<style lang="stylus">
.my-div-icon
  color #fff

.indicator-box
  position relative

.my-div-name
  font-size .08rem
  border 1px #fff solid
  border-radius 5px
  background-color rgba(15, 62, 112, .8)
  padding 2px 8px

.my-div-name:hover
  z-index 999
  font-size .09rem

.my-div-names
  font-size .07rem
  color #0F3F76
  position absolute
  top -34px
  left 15px
  width max-content
  padding .01rem .06rem
  border-radius 5px
  background #F0FF00
  transform translateX(-50%)
  &:before
    content: '';
    transform: translate(-35%,0);
    position: absolute;
    bottom: -9px;
    left: 50%;
    opacity: 1;
    border-top: solid 10px #F0FF00;
    border-right: solid 10px transparent;
    border-left: solid 10px transparent;
.my-div-names.lt
    background #FF9000
    &:before
        border-top-color #FF9000
</style>
